import { render, staticRenderFns } from "./ChatbotConversations.vue?vue&type=template&id=0182aa91"
import script from "./ChatbotConversations.vue?vue&type=script&lang=js"
export * from "./ChatbotConversations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports